/**
 * @generated SignedSource<<d828ba3c0c4fd982fe6cafb1d012a542>>
 * @relayHash a2a6906dfa64f3ad881b40d8376718e7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84ee4509b1df44eab6590551c21969b49e6bb5be78d6da8b92ac10cf943a91f2

import type { ConcreteRequest } from 'relay-runtime';
export type GoogleCalendarCardCurrentUserQuery$variables = Record<PropertyKey, never>;
export type GoogleCalendarCardCurrentUserQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
    } | null;
  };
};
export type GoogleCalendarCardCurrentUserQuery = {
  response: GoogleCalendarCardCurrentUserQuery$data;
  variables: GoogleCalendarCardCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GoogleCalendarCardCurrentUserQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GoogleCalendarCardCurrentUserQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "84ee4509b1df44eab6590551c21969b49e6bb5be78d6da8b92ac10cf943a91f2",
    "metadata": {},
    "name": "GoogleCalendarCardCurrentUserQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5d2f0452f0c6dd917bd2ecdcfd264df1";

export default node;
